// tslint:disable
import { inject, Service, service } from "./di";
import { BannerService } from "./BannerService";

// Branch.io integration service
@service
export class BranchService extends Service {
	@inject bannerService: BannerService;

	constructor() {
		super();
		this.init();
	}
	
	isSmartNews = () => {
		const urlParams = new URLSearchParams(window.location.search);
		let synd = urlParams.get('synd');
		if (!synd) {
			synd = sessionStorage.getItem("synd");
		}
		return synd === "smartnews";
	}

	init() {
		// https://flippit.atlassian.net/browse/SEO-865
		if (this.isSmartNews()) {
			return;
		}
		// @ts-ignore 
		(function(b, r, a, n, c, h, _, s, d, k){if (!b[n] || !b[n]._q){for (; s < _.length;)c(h, _[s++]); d = r.createElement(a); d.async = 1; d.src = "https://cdn.branch.io/branch-latest.min.js"; k = r.getElementsByTagName(a)[0]; k.parentNode.insertBefore(d, k); b[n] = h; }})(window, document, "script", "branch", function(b, r){b[r] = function(){b._q.push([r, arguments]); }; }, {_q: [], _v: 1}, "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);

		// @ts-ignore
		branch.init("key_live_ppOfQ7OzMmGfkwfsWRTsyekgqwkq3xxv");
	}

	sendSMS(number: string, options = {}) {
		const linkData = {
			channel: "Website",
			feature: "TextMeTheApp_FlyerBrowsing",
		};

		const callback = function(err: any) {
			if (err) {
				console.log("Something went wrong");
				console.log(err);
			} else {
				console.log("SMS sent!");
			}
		};
			// @ts-ignore
		branch.sendSMS(number, linkData, options, callback);
	}
}
